<template>
  <div class="py-16 px-8 text-center bg-main_blue">
    <div class="py-10">
      <h1 class="text-center text-white text-base font-bold mt-4 px-2 lg:px-1">
        Who We Are
      </h1>
      <p class="text-center text-white text-sm mt-4 px-2 lg:px-1">
        Mshel Group is a conglomerate comprising a diverse portfolio of
        companies committed to excellence, <br />
        innovation, and social impact across multiple sectors.
      </p>
    </div>

    <div
      class="mt-12 flex flex-col lg:flex-row justify-center gap-8 max-w-7xl mx-auto"
    >
      <!-- Vision Card -->
      <div
        class="card-hover bg-white shadow-2xl rounded-2xl overflow-hidden w-full lg:w-1/3 fade-in group"
      >
        <div class="vision-gradient h-2"></div>
        <div class="p-8">
          <div class="flex flex-col items-center text-center mb-6">
            <div class="icon-container rounded-full p-4 mb-4 pulse-icon">
              <svg
                class="w-12 h-12 text-pink-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                ></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                ></path>
              </svg>
            </div>
            <h3 class="text-2xl font-bold text-gray-800 mb-1">Our Vision</h3>
            <div
              class="w-16 h-1 bg-gradient-to-r from-pink-400 to-purple-500 rounded-full"
            ></div>
          </div>
          <p class="text-gray-600 leading-relaxed text-center">
To be the world's leading conglomerate transforming industries, enriching lives and advancing communities through innovation, ethical leadership and sustainable impact.
          </p>
        </div>
      </div>

      <!-- Mission Card -->
      <div
        class="card-hover bg-white shadow-2xl rounded-2xl overflow-hidden w-full lg:w-1/3 fade-in group"
      >
        <div class="mission-gradient h-2"></div>
        <div class="p-8">
          <div class="flex flex-col items-center text-center mb-6">
            <div class="icon-container rounded-full p-4 mb-4 pulse-icon">
              <svg
                class="w-12 h-12 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                ></path>
              </svg>
            </div>
            <h3 class="text-2xl font-bold text-gray-800 mb-1">Our Mission</h3>
            <div
              class="w-16 h-1 bg-gradient-to-r from-teal-400 to-blue-500 rounded-full"
            ></div>
          </div>
          <p class="text-gray-600 leading-relaxed text-center">
            We deliver exceptional customer value by adhering to integrity, Quality and Impact.
          </p>
        </div>
      </div>

      <!-- Core Values Card -->
      <div
        class="card-hover bg-white shadow-2xl rounded-2xl overflow-hidden w-full lg:w-1/3 fade-in group"
      >
        <div class="values-gradient h-2"></div>
        <div class="p-8">
          <div class="flex flex-col items-center text-center mb-6">
            <div class="icon-container rounded-full p-4 mb-4 pulse-icon">
              <svg
                class="w-12 h-12 text-orange-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                ></path>
              </svg>
            </div>
            <h3 class="text-2xl font-bold text-gray-800 mb-1">Our Core Values</h3>
            <div
              class="w-16 h-1 bg-gradient-to-r from-orange-400 to-red-500 rounded-full"
            ></div>
          </div>
          <div class="space-y-3 text-left">
            <div class="value-item text-gray-600">Integrity</div>
            <div class="value-item text-gray-600">Customer Centric</div>
            <div class="value-item text-gray-600">
              Excellence & Professionalism
            </div>
            <div class="value-item text-gray-600">Quality</div>
          </div>
        </div>
      </div>
    </div>

    <!-- strategic Goal -->
    <div class="md:px-10 max-w-screen-4xl mx-auto px-2 lg:px-12 pt-20">
      <div class="grid grid-cols-1 lg:grid-cols-2 items-center strategic-card">
        <!-- Left Image Section -->
        <div class="flex justify-center">
          <div class="overflow-hidden h-[600px]">
            <img
              src="../assets/images/group.png"
              alt="Mshel Group"
              class="w-full transition-transform duration-300 hover:scale-105 rounded-xl"
            />
          </div>
        </div>

        <!-- Right Content Section -->
        <div class="lg:px-6 lg:p-10 animate-fadeIn lg:-mt-16 px-2 -mt-64">
          <p class="text-white text-sm text-justify leading-relaxed mb-4">
            We are focused on enhancing quality of life, fostering innovation,
            and creating sustainable value across multiple sectors.
          </p>
          <p class="text-white text-sm leading-relaxed mb-4 text-justify">
            We work with industry experts to build a strong, unified brand
            emphasizing excellence, integrity, and social impact across all
            operations. This enables us to provide our customers with seamless
            experiences that reflect the Mshel Group’s core values, ensuring
            that all stakeholders recognize Mshel as synonymous with quality and
            community support.
          </p>
          <p class="text-white text-sm leading-relaxed mb-4 text-justify">
            Mshel Group foster a culture of innovation and driving long-term
            growth that positively impacts the communities we serve and sets new
            industry standards. We prioritize sustainable development through
            innovative practices and strategic investments that enhance economic
            and social value.
          </p>
          <p class="text-white text-sm text-justify leading-relaxed mb-4 mt-5">
            We are focused on enhancing quality of life, fostering innovation,
            and creating sustainable value across multiple sectors.
          </p>

          <!-- Buttons -->
          <div class="flex space-x-2 items-center mt-10">
            <router-link
              to="/about-us"
              class="relative px-8 py-2 text-white bg-yellow transition-all rounded-full border-2 border-transparent"
            >
              <span class="text-base">Explore more</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "whoWeAre",
  mounted() {
    // Add any Vue-specific logic here if needed
    // For example, intersection observer for animations
    this.setupAnimations();
  },
  methods: {
    setupAnimations() {
      // Optional: Add intersection observer for scroll-triggered animations
      const cards = document.querySelectorAll('.fade-in');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      });

      cards.forEach(card => {
        observer.observe(card);
      });
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.card-hover {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'Inter', sans-serif;
}

.card-hover:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.vision-gradient {
  background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #fecfef 100%);
}

.mission-gradient {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.values-gradient {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
}

.icon-container {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.value-item {
  position: relative;
  padding-left: 20px;
}

.value-item::before {
  content: '✦';
  position: absolute;
  left: 0;
  color: #f59e0b;
  font-weight: bold;
}

.fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease-out forwards;
}

.fade-in:nth-child(1) { animation-delay: 0.1s; }
.fade-in:nth-child(2) { animation-delay: 0.2s; }
.fade-in:nth-child(3) { animation-delay: 0.3s; }

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pulse-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}
</style>
